// extracted by mini-css-extract-plugin
export default {"container":"timer-box_container__2eQlF","label":"timer-box_label__136gK","timer":"timer-box_timer__1oifQ","traditionTheme":"timer-box_traditionTheme__15kKi"};